import { useState, useEffect } from "react";
import config from "../config";
import axios from "axios";

// Créez un nouveau composant ImageWithAuth
const ImageWithAuth = ({ src, alt, className, ...props }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImage = async () => {
      if (!src) {
        setLoading(false);
        return;
      }

      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.get(src, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'x-api-key': config.SITE_API_KEY 
          },
          responseType: 'blob'
        });

        const url = URL.createObjectURL(response.data);
        setImageUrl(url);
      } catch (error) {
        console.error("Erreur chargement image:", error);
        setImageUrl(null);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();

    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [src]);

  if (loading) {
    return <div className="w-full h-full bg-gray-200 animate-pulse" />;
  }

  return (
    <img
      src={imageUrl || "https://images.unsplash.com/photo-1507842742364-a136af112d4d?w=400&h=500&fit=crop"}
      alt={alt}
      className={className}
      {...props}
    />
  );
};
export default ImageWithAuth;